import { useState } from "react";
import API from "../services/api";
import "../styles/AuthPages.css";

function ForgotPasswordPage() {

  const [email, setEmail] = useState("");

  const sendResetLink = async () => {

    try {

      await API.post(
        "/users/forgot-password",
        { email }
      );

      alert(
        "Un lien de réinitialisation a été envoyé."
      );

    }

    catch(error) {

      alert(
        error.response?.data?.message ||
        "Erreur"
      );

    }

  };

  return (

    <div className="auth-page">

      <div className="auth-card">

        <h1>
          Mot de passe oublié
        </h1>

        <input
          type="email"
          placeholder="Votre email"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
        />

        <button
          onClick={sendResetLink}
        >
          Envoyer le lien
        </button>

      </div>

    </div>

  );

}

export default ForgotPasswordPage;